module.exports = __webpack_public_path__ + "static/lova-case-study-b1f4948021feec921edba63393af5264.webp";